export enum PressureUlcerStageEnum {
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  UTD = 5,
  Other = 99
}

export const PressureUlcerStageOptions = [
{ id: 1, label: '1' },
{ id: 2, label: '2' },
{ id: 3, label: '3' },
{ id: 4, label: '4' },
{ id: 5, label: 'UTD' },
{ id: 99, label: 'Other' }
];
